export default "__VITE_ASSET__B6Jr29jh__"